import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { withRouter } from 'react-router-dom';
import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import { COLORS } from '../../../../../utils/colors';
import { useTranslation, withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
moment.locale('es')

highchartsMore(Highcharts);
xRange(Highcharts);
class AvailabilityConsolidatedPerStep extends Component {

    constructor(props) {
        super(props);
        var periodical = false
        if (props.params.periodical == true){
            periodical = true
        }

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptionsStackedBarConsolidated: this._chartOptionsBase,
            chartOptionsStackedBarNode: this._chartOptionsBase,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            node: this.props.params.node,
            periodical:periodical,
        }
    }
    _chartOptionsBase = {
        chart: {
            type: 'xrange'
        },
        title: {
            text: "",
            style: {
                fontSize: '20px' 
             },
             margin: 25,
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: '',
                fontSize: '',
            }
        },
        xAxis: {
            type: 'datetime',
            gridLineWidth: 0,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
        },
        yAxis: {
            title: {
                text: '',
                style: {
                    fontSize: '' 
                 }
            },
            gridLineWidth: 0,
            reversed: true,
            labels: {
                useHTML:true,//set to true
                style:{
                    // width:'100px',
                    whiteSpace:'normal'//set to normal
                },
                step: 1,
                formatter: function () {//use formatter
                    return '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' + this.value + '</div>';
                }
            },
        },
        series: [{
            //name: 'Project 1',
            // pointPadding: 0,
            // groupPadding: 0,
            //borderColor: 'gray',
            pointWidth: 10,
            turboThreshold: 0,
            /*animation: {
                duration: 10000,
                // Uses Math.easeOutBounce
                easing: 'easeOutBounce'
            },*/
            animation: false,
            dataLabels: {
                enabled: true
            }
        }],
       
        plotOptions: {
            series: {
                borderRadius: '0px',
                borderColor: 'transparent',
                pointWidth: 10,
                turboThreshold: 0,
                grouping: false
            },
            xrange: {
                dataLabels: {
                    enabled: false
                },
                borderRadius: 0,
                grouping: false,
                borderWidth: 0,
                pointPadding: 0,
                borderColor: 'none'
            },
        },
        credits: {
            enabled: false
        },
        tooltip: {
            enabled: false,
        }
    }

    showFirstStep = () => {
        const { fromObjective } = this.props.location.state
        this.props.params.onInfo({ x: '', x2: '', y: '' }, fromObjective.Pasos[0].nombre_paso)
    }

    setHoverDataBar = (e) => {      
        const { x, x2, y, series, yCategory } = e.target 
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['x2'] = x2
        point['y'] = series.chart.yAxis[0].categories[y]
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if (props.params.node !== state.node) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                node: props.params.node,
                lastEvent: [],
                dataError: false,
                isLoading: true,
                hoverData: null,
                statePeriod: props.params.statePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptionsStackedBarConsolidated: state.chartOptionsBase,
                chartOptionsStackedBarNode: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.node !== this.state.node) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        this.props.params.onInfo({}, null)
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, node } = this.props.params
        const { history } = this.props;
        // puede necesitar agregar el schedule, guiarse por AvailabilityConsolidated
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        let nodeDowntime = 0
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            Promise.all([                
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoCustom/?user=${user}&key=${api_auth}&horarioId=0&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=${node}`),
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoDowntimeCustom/?user=${user}&key=${api_auth}&horarioId=0&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}&nodoId=${nodeDowntime}`)
            ])
                .then(([res1, res2]) => {
                    return Promise.all([res1.json(), res2.json()])
                })
                .then(([res1, res2]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino, res2)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            Promise.all([
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivo/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${period}&token=${token}&nodoId=${node}`),
                fetch(api_host+`/reporte/online/indicadores/getDetalleDisponibilidadParcialObjetivoDowntime/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&horarioId=0&t=${period}&token=${token}&nodoId=${nodeDowntime}`)
            ])
                .then(([res1, res2]) => {
                    return Promise.all([res1.json(), res2.json()])
                })
                .then(([res1, res2]) => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(res1, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino, res2)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino,
        externalDataConsolidated) => {
        const t = this.props.t; 
        const {periodical} = this.state      
        const { Paso, Objetivo_Nombre } = externalData.Objetivo
        const { estado } = externalDataConsolidated.Objetivo.Nodo[0]
        let lastEventDict = []
        let arrayChartDataStackedBar = [] 
 
        if (period === 'h') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
        } else if (period === 'd') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
        } else if (period === 'w') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
        } else if (period === 'c') {
            lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
        }
    
        let arrayChartDataStackedBarConsolidated = []
        const colors = ['#41B900', '#C2272D', '#A9A9A9', '#FFC600', '#1976d2'];      

        let dictDataStackedBarUptime = {}
        dictDataStackedBarUptime['name'] = t('availability-consolidated-per-step.chart.bar.name.uptime')
        dictDataStackedBarUptime['pointWidth'] = 40
        let arrayDataUptime = []

        let dictDataStackedBarDowntime = {}
        dictDataStackedBarDowntime['name'] = t('availability-consolidated-per-step.chart.bar.name.downtime')
        dictDataStackedBarDowntime['pointWidth'] = 40
        let arrayDataDowntime = []

        let dictDataStackedBarNoMon = {}
        dictDataStackedBarNoMon['name'] = t('availability-consolidated-per-step.chart.bar.name.no-monitoring')
        dictDataStackedBarNoMon['pointWidth'] = 40
        let arrayDataNoMon = []

        let dictDataStackedBarPartial = {}
        dictDataStackedBarPartial['name'] = t('availability-consolidated-per-step.chart.bar.name.partial')
        dictDataStackedBarPartial['pointWidth'] = 40
        let arrayDataPartial = []

        let dictDataStackedBarEvent = {}
        dictDataStackedBarEvent['name'] = t('availability-consolidated-per-step.chart.bar.name.maintenance')
        dictDataStackedBarEvent['pointWidth'] = 40
        let arrayDataEvent = []

        let dictDataStackedBarMarcadoAtentus = {}
        dictDataStackedBarMarcadoAtentus['name'] = t('availability-consolidated-per-step.chart.bar.name.atentus-marked-period')
        dictDataStackedBarMarcadoAtentus['pointWidth'] = 40
        let arrayDataMarcadoAtentus = []

        //Diccionarios y listas para información por nodos
        let dictDataStackedBarUptimeNode = {}
        dictDataStackedBarUptimeNode['name'] = t('availability-consolidated-per-step.chart.bar.name.uptime')
        dictDataStackedBarUptimeNode['pointWidth'] = 20
        let arrayDataUptimeNode = []

        let dictDataStackedBarDowntimeNode = {}        
        dictDataStackedBarDowntimeNode['name'] = t('availability-consolidated-per-step.chart.bar.name.downtime')
        dictDataStackedBarDowntimeNode['pointWidth'] = 20
        let arrayDataDowntimeNode = []

        let dictDataStackedBarNoMonNode = {}
        dictDataStackedBarNoMonNode['name'] = t('availability-consolidated-per-step.chart.bar.name.no-monitoring')
        dictDataStackedBarNoMonNode['pointWidth'] = 20
        let arrayDataNoMonNode = []

        let dictDataStackedBarPartialNode = {}
        dictDataStackedBarPartialNode['name'] = t('availability-consolidated-per-step.chart.bar.name.partial')
        dictDataStackedBarPartialNode['pointWidth'] = 20
        let arrayDataPartialNode = []

        let dictDataStackedBarEventNode = {}
        dictDataStackedBarEventNode['name'] = t('availability-consolidated-per-step.chart.bar.name.maintenance')
        dictDataStackedBarEventNode['pointWidth'] = 20
        let arrayDataEventNode = []
        
        let dictDataStackedBarMarcadoAtentusNode = {}
        dictDataStackedBarMarcadoAtentusNode['name'] = t('availability-consolidated-per-step.chart.bar.name.atentus-marked-period')
        dictDataStackedBarMarcadoAtentusNode['pointWidth'] = 20
        let arrayDataMarcadoAtentusNode = []

        Object.keys(estado).map((key) => {
            let dictDataStackedBar = {}

            let dateJson = new Date(estado[key]['fecha_desde'])
            let year = dateJson.getFullYear()
            let month = dateJson.getMonth()
            let day = dateJson.getDate()
            let hours = dateJson.getHours()
            let minutes = dateJson.getMinutes()
            let seconds = dateJson.getSeconds()

            let dateJsonEnd = (new Date(estado[key]['fecha_hasta']))
            let yearEnd = dateJsonEnd.getFullYear()
            let monthEnd = dateJsonEnd.getMonth()
            let dayEnd = dateJsonEnd.getDate()
            let hoursEnd = dateJsonEnd.getHours()
            let minutesEnd = dateJsonEnd.getMinutes()
            let secondsEnd = dateJsonEnd.getSeconds()

            dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
            dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
            dictDataStackedBar['y'] = 0
            if (estado[key]['nombre'] == 'uptime') {
                dictDataStackedBar['color'] = COLORS.UPTIME
                arrayDataUptime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME
                arrayDataDowntime.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'no monitoreo') {
                dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                arrayDataNoMon.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'downtime parcial') {
                dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                arrayDataPartial.push(dictDataStackedBar)
            }  else if (estado[key]['nombre'] == 'evento cliente') {
                dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                arrayDataEvent.push(dictDataStackedBar)
            } else if (estado[key]['nombre'] == 'marcado atentus') {
                dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                arrayDataMarcadoAtentus.push(dictDataStackedBar)
            }
        })

        let categoriedStep = []
        Object.keys(Paso).map((keyPaso) => {                   
            let estadoPaso = Paso[keyPaso]['estado'][0]['estadoDetalle']
            
            if (periodical == true) {
                let lengName = Paso[keyPaso]['paso_nombre']
            
                if (lengName.length > 15){
                    // categoriedStep.push(Paso[keyPaso]['paso_nombre'].substr(0,15) + "...")
                    categoriedStep.push(Paso[keyPaso]['paso_nombre'])
                }else{
                    categoriedStep.push(Paso[keyPaso]['paso_nombre'])
                }
            }else{
                categoriedStep.push(Paso[keyPaso]['paso_nombre'])
            }
            
            
            Object.keys(estadoPaso).map((key) => {              
                let dictDataStackedBar = {}
                                
                let dateJson = (new Date(estadoPaso[key]['fecha_desde'].substring(0, 19)))
                let year = dateJson.getFullYear()
                let month = dateJson.getMonth()
                let day = dateJson.getDate()
                let hours = dateJson.getHours()
                let minutes = dateJson.getMinutes()
                let seconds = dateJson.getSeconds()

                let dateJsonEnd = (new Date(estadoPaso[key]['fecha_hasta'].substring(0, 19)))
                let yearEnd = dateJsonEnd.getFullYear()
                let monthEnd = dateJsonEnd.getMonth()
                let dayEnd = dateJsonEnd.getDate()
                let hoursEnd = dateJsonEnd.getHours()
                let minutesEnd = dateJsonEnd.getMinutes()
                let secondsEnd = dateJsonEnd.getSeconds()

                dictDataStackedBar['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
                dictDataStackedBar['x2'] = Date.UTC(yearEnd,(monthEnd),dayEnd,hoursEnd,minutesEnd,secondsEnd)
                dictDataStackedBar['y'] = parseInt(keyPaso) 
                if (estadoPaso[key]['nombre'] == 'uptime') {
                    dictDataStackedBar['color'] = COLORS.UPTIME
                    arrayDataUptimeNode.push(dictDataStackedBar)
                } else if (estadoPaso[key]['nombre'] == 'downtime') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME
                    arrayDataDowntimeNode.push(dictDataStackedBar)
                } else if (estadoPaso[key]['nombre'] == 'no monitoreo') {
                    dictDataStackedBar['color'] = COLORS.NO_MONITOREO
                    arrayDataNoMonNode.push(dictDataStackedBar)
                } else if (estadoPaso[key]['nombre'] == 'downtime parcial') {
                    dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL
                    arrayDataPartialNode.push(dictDataStackedBar)
                } else if (estadoPaso[key]['nombre'] == 'evento cliente') {
                    dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE
                    arrayDataEventNode.push(dictDataStackedBar)
                } else if (estadoPaso[key]['nombre'] == 'marcado atentus') {
                    dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS
                    arrayDataMarcadoAtentusNode.push(dictDataStackedBar)
                }
            })
        })
        dictDataStackedBarUptime['data'] = arrayDataUptime
        dictDataStackedBarDowntime['data'] = arrayDataDowntime
        dictDataStackedBarNoMon['data'] = arrayDataNoMon
        dictDataStackedBarPartial['data'] = arrayDataPartial
        dictDataStackedBarEvent['data'] = arrayDataEvent
        dictDataStackedBarMarcadoAtentus['data'] = arrayDataMarcadoAtentus

        dictDataStackedBarUptimeNode['data'] = arrayDataUptimeNode
        dictDataStackedBarDowntimeNode['data'] = arrayDataDowntimeNode
        dictDataStackedBarNoMonNode['data'] = arrayDataNoMonNode
        dictDataStackedBarPartialNode['data'] = arrayDataPartialNode
        dictDataStackedBarEventNode['data'] = arrayDataEventNode
        dictDataStackedBarMarcadoAtentusNode['data'] = arrayDataMarcadoAtentusNode

        let heightNodeChart = 400
        
        if (Paso.length < 3) {
            heightNodeChart = 150
        } else if(Paso.length > 5 && Paso.length < 10) {
            heightNodeChart = 400
        } else if(Paso.length > 10) {
            heightNodeChart = 900
        }

        if (periodical == true) {
            if (Paso.length < 2 ) {
                heightNodeChart = 150
            }else if(Paso.length >= 2 && Paso.length <= 4) {
                heightNodeChart = 280    
            } else if(Paso.length > 5 && Paso.length < 10) {
                heightNodeChart = 500    
            } else if(Paso.length > 10) {
                heightNodeChart = 900
            } 
        }


        this.setState({
            chartOptionsStackedBarConsolidated: {
                pane: {
                    size: '100%',
                },
                yAxis: { categories: ['Consolidado']},                
        
                series: [dictDataStackedBarUptime, dictDataStackedBarDowntime, dictDataStackedBarNoMon, dictDataStackedBarPartial, dictDataStackedBarEvent, dictDataStackedBarMarcadoAtentus],
                plotOptions: {
                    series: {
                        datalabels: false,
                        cursor: 'pointer',
                        point: {
                            events: {
                                mouseOver: this.setHoverDataBar.bind(this),
                                mouseOut: this.showFirstStep
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: false
                    },
                    visible: false
                },
                chart: {
                    height: 100
                },
                
            },
            chartOptionsStackedBarNode: {
                //yAxis: { categories: ['isp1', 'isp2', 'isp3', 'isp4','isp5']}, 
                
                yAxis: { categories: categoriedStep}, 
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        point: {
                            events: {
                                mouseOver: this.setHoverDataBar.bind(this),
                                mouseOut: this.showFirstStep
                            }
                        }
                    }
                },
                series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictDataStackedBarEventNode, dictDataStackedBarMarcadoAtentusNode],
                legend: {
                    enabled: false
                },
                xAxis: {
                    labels: {
                        enabled: true
                    },
                    visible: true
                },
                chart: {
                    height: heightNodeChart
                },
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this.state.chartOptionsBase,
                yAxis: {...this.state.chartOptionsBase.yAxis, categories: categoriedStep},
                series: [dictDataStackedBarUptimeNode, dictDataStackedBarDowntimeNode, dictDataStackedBarNoMonNode, dictDataStackedBarPartialNode, dictDataStackedBarEventNode, dictDataStackedBarMarcadoAtentusNode],
                legend: {enabled: false},
                pane: {size: '%100'}
            }
        }, this.showFirstStep);

    }
    render() {
        const { dataError, chartOptionsStackedBarConsolidated, chartOptionsStackedBarNode, isLoading ,chartOptionsBase} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const t = this.props.t;
        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityConsolidatedPerStep",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptionsStackedBarConsolidated={chartOptionsStackedBarConsolidated} chartOptionsStackedBarNode={chartOptionsStackedBarNode} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>{t('availability-consolidated-per-step.error')}</p>)

    }
}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>
                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"
                      size={24}
                      thickness={4}
                    />
                    <br/>
                    {t('text.loading')}
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                
                <PerfectScrollbar>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarConsolidated} />
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={props.chartOptionsStackedBarNode} />
                </PerfectScrollbar>
            </div>
        </div>
    )
}


export default compose(withRouter, withTranslation())(AvailabilityConsolidatedPerStep);